import type { ReactNode } from "react";
import React from "react";

import { PageHandler } from "./PageHandler";
import PageStateProvider from "./PageStateProvider";
import { RoutesProvider } from "./router";
import type { RouteMatcher } from "./router/routeMatcher";
import type { OdigeoRouterNavigate } from "./router/router";
import type { PageHandlerType } from "./types";

export interface RoutingProviderProps {
  routeMatcher: RouteMatcher;
  pageHandler: Partial<PageHandlerType>;
  odigeoNavigate: OdigeoRouterNavigate;
  children: ReactNode;
}

const defaultPageHandler = PageHandler();
export const RoutingProvider = ({
  routeMatcher,
  pageHandler,
  odigeoNavigate,
  children,
}: RoutingProviderProps) => (
  <RoutesProvider routeMatcher={routeMatcher}>
    <PageStateProvider
      {...defaultPageHandler}
      {...pageHandler}
      odigeoNavigate={odigeoNavigate}
    >
      {children}
    </PageStateProvider>
  </RoutesProvider>
);
